import React from "react";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';


class MensajeError extends React.Component {

    constructor(props) {
        super(props);
        this.state = {mostrar: false, error: null};
    }

    componentDidUpdate(prevProps) {
        let error = null;
        let ocultar = null;
        Object.entries(this.props.state).forEach(
            ([key, value]) => {
                var valuePrev = prevProps.state[key];
                if (value.create && valuePrev && valuePrev.create && !value.create.isCreating && valuePrev.create.isCreating && value.create.error) {
                    error = value.create.error;
                }
                if (value.create && valuePrev && valuePrev.create && value.create.isCreating && !valuePrev.create.isCreating) {
                    ocultar = true;
                }
                if (value.update && valuePrev && valuePrev.update && !value.update.isUpdating && valuePrev.update.isUpdating && value.update.error) {
                    error = value.update.error;
                }
                if (value.delete && valuePrev && valuePrev.delete && !value.delete.isDeleting && valuePrev.delete.isDeleting && value.delete.error) {
                    error = value.delete.error;
                }
                if (value.notify && valuePrev && valuePrev.notify && !value.notify.isNotifying && valuePrev.notify.isNotifying && value.notify.error) {
                    error = value.notify.error;
                }
            });
        if (this.state.mostrar != (error != null) && error != null && Object.keys(error).length > 0) {
            this.setState({mostrar: true, error: error});
        } else if (ocultar === true)
            this.setState({mostrar: false, error: null});
    }


    render() {
        const {mostrar, error} = this.state;
        let Errores = "";
        if (error != null && Object.keys(error).length > 0 && typeof error == "object") {
            Errores = Object.keys(error).map((nombre, index) => {
                let mensajeCompleto = "";
                if (error[nombre])
                    error[nombre].forEach((mensaje) => {
                        mensajeCompleto += mensaje;
                    });
                return <p key={nombre} style={{margin: "0px"}}>{mensajeCompleto}</p>;
            });
        } else
            Errores = <p key={0} style={{margin: "0px"}}>{error}</p>;

        return (
            <section className="modal-cv"
                     style={{display: mostrar ? "flex" : "none"}}>
                <div className="modal-cv-body">
                    <div className="modal-spiner">
                        <div className="">😖</div>
                    </div>
                    <div className="modal-text">
                        {Errores}
                    </div>
                </div>
            </section>
        )
    }
}

function mapStateToProps(state) {
    return {
        state: state,
    };
}

// Wrap the component to inject dispatch and state into it
export default withRouter(connect(mapStateToProps)(MensajeError));



// WEBPACK FOOTER //
// ./src/layout/Mensajes/MensajeError.js